// 参照组件类型(表参照/树参照/树表参照)
export const REFER_TYPE = {
  TABLE: 'Table',
  TREE_TABLE: 'TreeTable',
  TREE: 'Tree',
  from: function (value: any) {
    switch (value) {
    case "TreeTable":
      return REFER_TYPE.TREE_TABLE;
    case "Tree":
      return REFER_TYPE.TREE;
    default:
      return REFER_TYPE.TABLE; // Default
    }
  }
}

// 参照组件选择类型(单选/多选)
export const REFER_SELECT_TYPE = {
  SINGLE: 'single',
  MULTIPLE: 'multiple',
  from: function (value: any) {
    switch (value) {
    case "multiple":
      return REFER_SELECT_TYPE.MULTIPLE;
    default:
      return REFER_SELECT_TYPE.SINGLE; // Default
    }
  }
}

// 参照组件渲染环境(pc端/移动端)
export const REFER_EQUIPMENT = {
  PC: 'pc',
  MOBILE: 'mobile',
  from: function (value: any) {
    switch (value) {
    case "pc":
      return REFER_EQUIPMENT.PC;
    default:
      return REFER_EQUIPMENT.MOBILE;
    }
  }
}

export const PAGE_MOD_BROWSE = 'BROWSE'
export const PAGE_MOD_EDIT = 'EDIT'
export const PAGE_MOD_ADD = 'ADD'

export const API_SCOPE_GLOBAL = 'GLOBAL'

export const QTM_DEBUG_STORE = 'QTM_DEBUG_STORE'

export const BILL_EDIT_MODE_MODAL = 'MODAL'

export const ENV_RENDER_DESIGNER = 'designer'

export const FORM_SPANS = {
  xxl: 6, xl: 5, lg: 4, md: 3, sm: 2, xs: 1
}
